import { combineReducers } from 'redux';
import { createMultilanguageReducer } from 'redux-multilanguage';
import { aetherApi } from '../api/aetherApi';
import blogsReducer from './blogsReducer';
import cartReducer from './cartReducer';
import checkoutReducer from './checkoutReducer';
import compareReducer from './compareReducer';
import currencyReducer from './currencyReducer';
import featureProductReducer from './featureProductReducer';
import loginReducer from './loginReducer';
import productReducer from './productReducer';
import shopReducer from './shopReducer';
import wishlistLabelReducer from './wishlistLabelReducer';
import wishlistReducer from './wishlistReducer';

const rootReducer = combineReducers({
  multilanguage: createMultilanguageReducer({ currentLanguageCode: 'en' }),
  currencyData: currencyReducer,
  productData: productReducer,
  userData: loginReducer,
  cartData: cartReducer,
  blogData: blogsReducer,
  wishlistData: wishlistReducer,
  compareData: compareReducer,
  featureProductData: featureProductReducer,
  shopData: shopReducer,
  checkout: checkoutReducer,
  wishlistLabel: wishlistLabelReducer,
  [aetherApi.reducerPath]: aetherApi.reducer,
});

export default rootReducer;
